import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/styles';
import Pagination from '@material-ui/lab/Pagination';
import SearchIcon from '@material-ui/icons/Search';

import { useStyles } from './styles.js';

import { graphql, QueryRenderer } from 'react-relay';
import environment from '../../environment';
import { CircularProgress } from '@material-ui/core';
import LeaderboardPopover from '../../routes/front/wmpo/wmpoLeaderboard/components/LeaderboardPopover';

class LeaderboardTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      selected: {},
      event_id: this.props.event_id,
      width: window.innerWidth
    };
    this.dlOpen = this.dlOpen.bind(this);
    this.dlClose = this.dlClose.bind(this);
  }

  componentDidMount() {

  }

  dlOpen(e) {
    let selected = {
      guest: {
        _id: e._id,
        guest_name: e.guest_name,
        fantasy_points: e.fantasy_points,
      }
    }
    this.setState({ open: true, selected: selected });
  }

  dlClose() {
    this.setState({ open: false, selected: {} });
  }

  render() {
    const { classes } = this.props;
    const mobile = this.state.width <= 760;
    return (
      <>
        <table className={classes.leaderBoardTable}>
          <thead>
            <tr>
              <th scope="col" className={classes.placeCol}>
                Place
              </th>
              <th scope="col" className={classes.nameCol}>
                Company
                {this.props.data && this.props.data.number_of_guests > 30 && (
                  <span className={classes.searchDiv}>
                    <SearchIcon />
                  </span>
                )}
              </th>
              <th scope="col" className={classes.pointsCol}>
                Score
              </th>
              <th scope="col" className={classes.pointsCol}>
                CTP(in.)
              </th>
            </tr>
          </thead>
          <tbody className={classes.tbody}>
            {this.props.records &&
              this.props.records.map((record, i) => {
                return (
                  <tr key={i}>
                    <td data-label="Place" className={classes.placeTr}>
                      <span className={classes.index}>{i + 1}</span>
                    </td>
                    <td data-label="Name" className={classes.nameTr}>
                      <h2 className={classes.guestDetails}>
                        {record.guest_name}
                      </h2>
                    </td>
                    <td data-label="Points" className={classes.pointsCol}>
                      <h2 className={classes.guestDetails}>
                        {record.fantasy_points}
                      </h2>
                    </td>
                    <td data-label="Points" className={classes.pointsCol}>
                      <h2 className={classes.guestDetails}>{record.score}</h2>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>

        {this.state.open && Object.keys(this.state.selected).length > 0 && (
          <QueryRenderer
            environment={environment}
            query={graphql`
              query LeaderboardTableQuery(
                $draftArguments: draftAnswersInputType
              ) {
                getDraftAnswers(draftArguments: $draftArguments) {
                  code
                  message
                  data {
                    _id
                    option_name
                    points
                  }
                }
              }
            `}
            variables={{
              draftArguments: {
                guest_id: this.state.selected.guest._id,
                event_id: this.state.event_id,
              },
            }}
            render={({ error, props }) => {
              if (error) {
                return <div>No Records Found.</div>;
              } else if (props) {
                return (
                  <LeaderboardPopover
                    open={open}
                    dlClose={this.dlClose}
                    mobile={mobile}
                    selected={this.state.selected.guest}
                    selections={props.getDraftAnswers.data}
                  />
                );
              } else {
                return (
                  <CircularProgress
                    style={{ marginLeft: '50%', marginTop: '25%' }}
                  />
                );
              }
            }}
          />
        )}

        {this.props.data && this.props.data.number_of_guests > 30 && (
          <Pagination
            page={this.state.page}
            count={Math.ceil(this.props.data.number_of_guests / 30)}
            classes={{
              ul: classes.pagination,
            }}
            onChange={(event, page) => this.props.handlePageChange(event, page)}
          />
        )}
      </>
    );
  }
}

LeaderboardTable.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(LeaderboardTable);
